import {createControlComponent} from "@react-leaflet/core";
import Locate from "leaflet.locatecontrol";

const LocateControl = (props) => {
    const {options} = props;
    return new Locate({icon: 'fa fa-map-marker', ...options});
}

export default createControlComponent((props) => LocateControl(props));